<div class="flex-center fl-col gap-1">
    <div class="payment-success-animation">
        <ng-lottie width="150px" height="120px" [options]="options"></ng-lottie>
      </div>  
        <div class="text-xs text-[#53565B] font-semibold"> One moment while we connect to {{header_title}}</div>
</div>